import Vue from 'vue';
import VueRouter from 'vue-router';
import WrenwoodComingSoon from 'JS/blain-brands/WrenwoodComingSoon.vue';

Vue.use(VueRouter);

const el = document.querySelector < HTMLElement > ('#wrenwoodComingSoon');
if (el) {
	new Vue({
		el,
		render: h => h(WrenwoodComingSoon)
	});
}